import { Injectable } from '@angular/core';import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CloseButtonService {
  private _btnVisible$ = new BehaviorSubject(false);
  btnVisible$ = this._btnVisible$.asObservable();

  private _btnClicked$ = new Subject();
  btnClicked$ = this._btnClicked$.asObservable();

  isVisible() {
    return this._btnVisible$.value;
  }
  showButton() {
    this._btnVisible$.next(true);
    // console.log('show')
  }
  hideButton() {
    this._btnVisible$.next(false);
  }

  btnClicked(event: Event) {
    event.stopPropagation();
    this._btnClicked$.next(true);
  }
}
